import React from 'react';
import PropTypes from 'prop-types';
import { FaCcVisa, FaEdit, FaTrashAlt } from 'react-icons/fa';
import { formatNumber, formatNumberCurrency } from 'helpers/utils';
import BookingAttachment from '../../BookingAttachment';

const OtherItem = ({ booking, record, editShuttleBooking, deleteShuttleBooking, handleRemoveAttachment }) => {
  const isUSDCurrency = booking.currency === 'USD';

  return (
    <div className="tw-border tw-border-solid tw-border-slate-200 tw-rounded tw-p-4 tw-mb-4 tw-bg-white tw-text-sm">
      <div className="tw-flex tw-items-start tw-justify-between tw-mb-3">
        <div className="tw-flex tw-items-center tw-gap-3">
          <h5 className="tw-mb-0 tw-text-blue-700 tw-flex tw-items-center tw-gap-1">{record?.name === 'Visa' ? <FaCcVisa /> : null} {record.name}</h5>
          <div className="tw-flex tw-items-center tw-gap-2 tw-text-slate-500">
            <button type="button" title="Edit" onClick={editShuttleBooking} className="tw-bg-transparent tw-border-0 tw-cursor-pointer hover:tw-text-blue-600 tw-p-0"><FaEdit /></button>
            <button type="button" title="Delete" onClick={deleteShuttleBooking} className="tw-bg-transparent tw-border-0 tw-cursor-pointer hover:tw-text-red-600 tw-p-0"><FaTrashAlt /></button>
          </div>
        </div>
        <small className="tw-text-slate-500">Created date: <strong>{record.created_date}</strong> | By: <strong>{record.created_by}</strong></small>
      </div>

      <div className="tw-flex tw-gap-2 tw-mb-1.5">
        <span className="tw-w-24 tw-flex-shrink-0 tw-text-slate-600">Description</span>
        <span className="tw-text-blue-700">{record.description}</span>
      </div>
      <div className="tw-flex tw-gap-2 tw-mb-1.5">
        <span className="tw-w-24 tw-flex-shrink-0 tw-text-slate-600">Note</span>
        <span className="tw-text-blue-700" dangerouslySetInnerHTML={{ __html: record.notes }} />
      </div>

      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 tw-mt-4">
        <div>
          <h6 className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-text-slate-500 tw-mb-2">Attachments</h6>
          <div className="tw-flex tw-flex-wrap tw-gap-1">
            {(record.documents || []).map((attachment) => (
              <BookingAttachment
                {...attachment}
                key={attachment.id}
                handleRemoveAttachment={(documentId) => handleRemoveAttachment(record.id, documentId)}
              />
            ))}
          </div>
        </div>
        <div>
          <div className="tw-flex tw-justify-between tw-mb-1.5"><span className="tw-font-semibold tw-text-slate-600">Amount currency</span><span className="tw-text-blue-700">{formatNumberCurrency(record.amount_currency, record.currency)}</span></div>
          {isUSDCurrency && <div className="tw-flex tw-justify-between tw-mb-1.5"><span className="tw-font-semibold tw-text-slate-600">Exchange rate</span><span className="tw-text-blue-700">{formatNumber(record.exchange_rate)} VND</span></div>}
          <div className="tw-flex tw-justify-between tw-mb-1.5"><span className="tw-font-semibold tw-text-slate-600">Amount</span><span className="tw-text-blue-700">{formatNumberCurrency(record.amount, 'VND')}</span></div>
        </div>
      </div>
    </div>
  );
};

OtherItem.propTypes = {
  booking: PropTypes.object.isRequired,
  record: PropTypes.object.isRequired,
  editShuttleBooking: PropTypes.func.isRequired,
  deleteShuttleBooking: PropTypes.func.isRequired,
  handleRemoveAttachment: PropTypes.func.isRequired,
};

export default OtherItem;
